module.exports = __webpack_public_path__ + "static/media/hero.5fdfe07f.jpg";